import dayjs from 'dayjs';
import 'dayjs/locale/pt-br';

dayjs.locale('pt-br');

export const formatDateTimeToString = (rawDate?: string): string => {
  const date = dayjs(rawDate);

  const formattedDate = date.format('DD/MM/YYYY');
  const formattedTime = date.format('HH:mm');

  return `${formattedDate} às ${formattedTime}`;
};
